import { BrowserRouter, Route, Routes } from "react-router";
import RestaurantPage from "./Pages/RestaurantPage"; // New component for listing restaurants
import TablePromptPage from "./Pages/TablePromptPage"; // Component for QR code prompt
import OrderPage from "./Pages/OrderPage";
import CheckoutPage from "./Pages/CheckoutPage";
import Layout from "./RouteComponents/Layout";
import NotFound from "./Pages/NotFound";
import ScrollToTop from "./RouteComponents/ScrollToTop";
import data from "./util/protype"
import OrderStatusPage from "./Pages/OrderStatusPage";
import './App.css'
import ProfilePage from "./Pages/ProfilePage";
import { AppProvider } from "./Context";
import WithRestaurantProvider from "./RouteComponents/WithRestaurantProvider";
import LoginPage from "./Pages/LoginPage";
import AuthRouter from "./RouteComponents/AuthRouter";

function App() {
  return (
      <BrowserRouter>
      <AppProvider>
        <ScrollToTop/>
        <Routes>
          {/* Default route - Lists all available restaurants */}
          <Route path="/" element={<RestaurantPage />} />

          {/* Restaurant selected, but no table */}
          <Route path="/:restaurant" element={
            <WithRestaurantProvider>
              <Layout />
            </WithRestaurantProvider>
          }>

            {/* The default route inside /:restaurant */}
            <Route index element={<TablePromptPage />} />

            {/* Routes under /:restaurant */}
            <Route path="order" element={<OrderPage />} />
            <Route path="checkout" element={<CheckoutPage />} />
            <Route path="order/:orderId" element={<OrderStatusPage />} />

            {/* Direct route under /:restaurant */}
            <Route path="profile" element={<AuthRouter />}>
  <Route index element={<ProfilePage />} />
  <Route path="login" element={<LoginPage />} />
</Route>

            
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
        </AppProvider>
      </BrowserRouter>
  );
}

export default App;
